module.exports = __webpack_public_path__ + "static/media/Inertia_theory_q1.130bb9d6.mp4";